import React from 'react';
import './Card.css';

interface Props {
  title: string;
  subtitle?: string;
  children: React.ReactNode;
  image: React.ReactNode;
}

const Accordion: React.FC<Props> = ({ title, subtitle, image, children }): JSX.Element => {
  return (
    <div className="card">
      <div className="card-header flex items-center">
        {image}

        <div>
          <h3>{title}</h3>
          {subtitle && <p>{subtitle}</p>}
        </div>
      </div>

      {children}
    </div>
  );
};

export default Accordion;
